<span [attr.id]="targetId()"
      class="td-wb-targeted-ad__container">
</span>
